// Libs
import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
// Context
import Button from '@material-ui/core/Button';
import { toast } from 'react-toastify';
import { useComponentsPool } from '../../../../ComponentsPool';
import { Toast } from '../../../notification/components';
import { useModal } from '../../../modal/ModalContext';
// Actions
import createLoadingSelector from '../../../layout/actions';
import { getDeviceList, addDeviceCsvFile, getLastReceivedDeviceData } from '../../actions';

const loadingSelector = createLoadingSelector(['ADD_DEVICE_CSV_FILE']);
const DeviceAddPopup = () => {
    const isLoading = useSelector(state => loadingSelector(state.layout.loading));
    const { Component } = useComponentsPool();
    const [t] = useTranslation();
    const dispatch = useDispatch();
    const modal = useModal();
    const choosePicture = React.createRef();
    const [csvFile, setCsvFile] = useState('');
    const [isCompliantCsvFile, setIsCompliantCsvFile] = useState(false);

    const showUploader = () => {
        choosePicture.current.click();
    };

    const fileChangedHandler = e => {
        e.preventDefault();
        if (e.target.files?.length > 0) {
            setCsvFile(e.target.files[0]);
            if (e.target.files[0].size < 2500000) {
                setIsCompliantCsvFile(true);
            } else {
                setIsCompliantCsvFile(false);
                toast(
                    <Toast
                        isConfirm
                        message={t('notifications:is_not_compliant_device_csv')}
                        icon={'frown'}
                        type={'error'}
                    />, {
                        position: toast.POSITION.BOTTOM_LEFT,
                        className: 'normal',
                        bodyClassName: 'notification-body grow-font-size',
                        progressClassName: 'error-custom-progress-bar'
                    }
                );
            }
        }
    };

    const addDevices = async () => {
        dispatch(addDeviceCsvFile(csvFile))
            .then(() => {
                dispatch(getDeviceList()).then(() => dispatch(getLastReceivedDeviceData()));
                modal.close();
            });
    };

    const Form = (
        <div className={'device-add-popup'}>
            <div className={'add-csv-file'}>
                <div className='doc-links'>
                    <a href="https://www.notion.so/merciyanis/cdbb5e99f22147609f0ac95a745ba2ac?v=65e832ca407d48a48473dd5f199d9f44&pvs=4" rel="noopener noreferrer" target="_blank">
                        {t('devices:add_csv_file_doc_link')}
                    </a>
                    <br />
                    <br />
                    <a href="https://drive.google.com/drive/u/0/folders/1lDK9clbVIzLqgOBjiI7ivbbFtS8dGA-Z" rel="noopener noreferrer" target="_blank">
                        {t('common:csv_link')}
                    </a>
                </div>
                <Button
                    onClick={showUploader}
                >
                    <span>{t('devices:add_devices_csv_file')}</span>
                </Button>
            </div>
            <input
                ref={choosePicture}
                hidden
                type="file"
                accept=".csv"
                onChange={e => fileChangedHandler(e)}
            />
            <div>
                <span>{t('devices:chosen_file') + (csvFile ? ` ${ csvFile.name}` : ` ${ t('common:none')}`)}</span>
            </div>
        </div>
    );

    const disableSave = !isCompliantCsvFile || !csvFile;

    return (
        <>
            <Component componentName={'LoaderBarTop'} isLoading={isLoading} />
            <Component
                componentName={'Modal'}
                noOverflow
                head={<span className={'title-ticket-create-popup'}>{t('devices:add_devices')}</span>}
                content={Form}
                classNames={'ticket-create-popup'}
                submitButton
                submitButtonLabel={'common:save'}
                onHandleSubmit={addDevices}
                onSubmitDisabled={disableSave}
            />
        </>
    );
};
export default DeviceAddPopup;
